<template>
    <div class="container container-tabs">
        <el-tabs v-model="activeName" @tab-click="handleClick" type="card">
            <el-tab-pane name="all" class="to-searh">
                <span slot="label" class="table-title">全部</span>
            </el-tab-pane>

            <el-tab-pane :name="String(item.val)" v-for="(item, index) in value_status_array" :key="index" class="to-searh">
                <span slot="label" class="table-title">{{ item.alias }}</span>
            </el-tab-pane>

            <div style="display: flex">
                <div class="handle-box" style="width: 50%">
                    <el-row class="head-search">
                        <el-col :span="12">
                            <span class="title">司机名称:</span>
                            <!-- 搜索司机名称-->
                            <el-input
                                v-model="search_data.name"
                                placeholder="请输入司机名称"
                                class="handle-input mr10"
                                @keyup.enter.native="searchDriverLists"
                            ></el-input>
                        </el-col>

                        <el-col :span="12">
                            <span class="title">手机号码:</span>
                            <!-- 搜索手机号码 -->
                            <el-input
                                v-model="search_data.phone"
                                placeholder="请输入手机号码"
                                class="handle-input mr10"
                                maxlength="11"
                                @keyup.enter.native="searchDriverLists"
                            >
                            </el-input>
                        </el-col>
                    </el-row>

                    <el-row class="head-search">
                        <el-col :span="12">
                            <span class="title">真实姓名:</span>
                            <!-- 搜索司机名称-->
                            <el-input
                                v-model="search_data.real_name"
                                placeholder="请输入真实姓名"
                                class="handle-input mr10"
                                @keyup.enter.native="searchDriverLists"
                            ></el-input>
                        </el-col>
                        <el-col :span="12">
                            <span class="title">身份证号:</span>
                            <!-- 搜索司机名称-->
                            <el-input
                                v-model="search_data.id_card"
                                placeholder="请输入身份证号"
                                class="handle-input mr10"
                                @keyup.enter.native="searchDriverLists"
                            ></el-input>
                        </el-col>
                    </el-row>

                    <el-row class="head-search">
                        <el-col :span="12">
                            <span class="title">全职兼职:</span>
                            <el-select
                                style="width: 150px"
                                v-model="search_data.signing_type"
                                placeholder="请选择"
                                clearable
                                @keyup.enter.native="searchDriverLists"
                            >
                                <el-option label="按天签约" value="0"> </el-option>
                                <el-option label="按月签约" value="1"> </el-option>
                                <el-option label="按单签约" value="2"> </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="12">
                            <span class="title">保险状态:</span>

                            <el-select
                                style="width: 150px"
                                v-model="search_data.insurance_status"
                                placeholder="请选择"
                                clearable
                                @keyup.enter.native="searchDriverLists"
                            >
                                <el-option :label="item.alias" :value="item.val" v-for="(item, index) in insurance_status" :key="index">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                    <el-row class="head-search">
                        <el-col :span="12">
                            <span class="title">司机身份:</span>
                            <el-select
                                style="width: 150px"
                                v-model="search_data.capacity"
                                placeholder="请选择"
                                clearable
                                @keyup.enter.native="searchDriverLists"
                            >
                                <el-option label="兼职司机" value="part_time"> </el-option>
                                <el-option label="全职司机" value="full_time"> </el-option>
                                <el-option label="保底大师" value="master"> </el-option>
                                <el-option label="组长" value="headman"> </el-option>
                                <el-option label="监察长" value="supervision"> </el-option>
                                <el-option label="队领导" value="manage"> </el-option>
                                <el-option label="大队长" value="captain"> </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="12">
                            <span class="title">司机段位:</span>
                            <el-select
                                style="width: 150px"
                                v-model="search_data.dan"
                                placeholder="请选择"
                                clearable
                                @keyup.enter.native="searchDriverLists"
                            >
                                <el-option :label="item.v" :value="item.k" v-for="(item, index) in dan_select" :key="index"> </el-option>
                            </el-select>
                        </el-col>
                    </el-row>

                    <el-row class="head-search">
                        <el-col :span="12">
                            <span class="title">注册时间:</span>

                            <el-date-picker
                                v-model="search_time"
                                type="datetimerange"
                                range-separator="-"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                @change="timeChange"
                                style="width: 350px"
                            >
                            </el-date-picker>
                        </el-col>
                    </el-row>
                    <el-row class="head-search">
                        <el-col :span="12">
                            <el-button :class="more_search ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" @click="more_search = !more_search">
                                详细搜索
                            </el-button>
                        </el-col>
                    </el-row>

                    <div v-show="more_search" style="margin-top: 10px">
                        <!-- 搜索性别 -->
                        <el-row class="head-search">
                            <el-col :span="24" style="margin: 10px 0">
                                <span class="title">性别:</span>
                                <el-radio-group v-model="search_data.sex" size="small">
                                    <el-radio label="" border> 全部 </el-radio>
                                    <el-radio v-for="(item, index) in val_sex_array" :key="index" :label="String(item.val)" border>
                                        {{ item.alias }}
                                    </el-radio>
                                </el-radio-group>
                            </el-col>
                        </el-row>

                        <el-row class="head-search">
                            <el-col :span="24" style="margin: 10px 0">
                                <span class="title">司机警示灯:</span>
                                <el-radio-group v-model="search_data.insurance_alarm" size="small">
                                    <el-radio label="" border> 全部 </el-radio>
                                    <el-radio label="1" border> 黄 </el-radio>
                                    <el-radio label="2" border> 红 </el-radio>
                                </el-radio-group>
                            </el-col>
                        </el-row>

                        <!--                    <el-row class="head-search">-->
                        <!--                        <el-col :span="24" style="margin: 10px 0">-->
                        <!--                            <span class="title">签约规则:</span>-->
                        <!--                            <el-radio-group v-model="search_data.insurance_alarm" size="small">-->
                        <!--                                <el-radio label="" border>全部</el-radio>-->
                        <!--                                <el-radio label="1" border>按月</el-radio>-->
                        <!--                                <el-radio label="2" border>按天</el-radio>-->
                        <!--                                <el-radio label="2" border>按单</el-radio>-->
                        <!--                            </el-radio-group>-->
                        <!--                        </el-col>-->
                        <!--                    </el-row>-->
                    </div>
                </div>

                <div style="border: 1px solid #e4e4e4; border-radius: 10px; padding: 10px; margin-bottom: 10px; width: 50%">
                    <!-- echarts图表 -->
                    <!-- 查询条件 -->
                    <div style="float: right">
                        <el-radio-group v-model="line_value" size="mini" @change="linChange">
                            <el-radio-button label="0" border>日</el-radio-button>
                            <el-radio-button label="1" border>月</el-radio-button>
                        </el-radio-group>
                    </div>
                    <!-- 折现图 -->
                    <div style="width: 100%; margin-top: 40px">
                        <div id="activeChartsDriver" style="height: 300px"></div>
                        <div class="monthCharts-bg" style="height: 400px; text-align: center" v-show="!echarts_loading">
                            <i class="el-icon-loading" v-if="activeChartsDriver_text != '暂无数据'"></i>
                            <p>{{ activeChartsDriver_text }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <el-button type="primary" icon="el-icon-search" @click="searchDriverLists">搜索</el-button>
                <el-button @click="add_isShow = !add_isShow">添加</el-button>
                <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
                <el-button @click="water_isShow = !water_isShow">司机资金流水</el-button>
                <!-- <el-button @click="exportData">导出司机业绩</el-button> -->
            </div>
        </el-tabs>

        <!-- 表格 -->
        <el-table
            :data="tableData"
            style="width: 100%"
            ref="multipleTable"
            header-cell-class-name="table-header"
            @selection-change="handleSelectionChange"
        >
            <!-- <el-table-column type="selection" width="55" align="center" prop="driver_code"></el-table-column> -->
            <el-table-column type="expand">
                <template slot-scope="props">
                    <el-form label-position="left" inline class="demo-table-expand">
                        <div class="more-style">
                            <el-form-item label="创建时间:">
                                <span>{{ props.row.reg_time.Ymd }}</span>
                            </el-form-item>
                            <el-form-item label="创建详细时间:">
                                <span>{{ props.row.reg_time.YmdHis }}</span>
                            </el-form-item>
                            <el-form-item label="更改时间:">
                                <span>{{ props.row.edit_time.YmdHis }}</span>
                            </el-form-item>
                        </div>
                        <div class="more-style">
                            <el-form-item label="更改详细时间:">
                                <span>{{ props.row.edit_time.YmdHis }}</span>
                            </el-form-item>
                            <el-form-item label="app版本:">
                                <span>{{ props.row.app_version }}</span>
                            </el-form-item>
                            <el-form-item label="注册来源:">
                                <span>{{ props.row.reg_from }}</span>
                            </el-form-item>
                        </div>

                        <div class="more-style">
                            <el-form-item label="紧急联系人:">
                                <span>{{ props.row.urgent_name }}</span>
                            </el-form-item>
                            <el-form-item label="紧急联系人电话:">
                                <span>{{ props.row.urgent_phone }}</span>
                            </el-form-item>
                            <el-form-item label="家庭地址:">
                                <span>{{ props.row.address }}</span>
                            </el-form-item>
                        </div>

                        <div class="more-style">
                            <el-form-item label="所属城市:">
                                <span>{{ props.row.city.name }}</span>
                            </el-form-item>
                            <el-form-item label="极光编码:">
                                <span>{{ props.row.registration_id }}</span>
                            </el-form-item>
                            <el-form-item> </el-form-item>
                        </div>

                        <div>
                            <el-form-item label="备注:">
                                <span>{{ props.row.remarks }}</span>
                            </el-form-item>
                        </div>

                        <div>
                            <el-form-item label="系统备注:">
                                <span>{{ props.row.system_remarks }}</span>
                            </el-form-item>
                        </div>
                    </el-form>
                </template>
            </el-table-column>

            <!-- <el-table-column prop="id" label="id" min-width="80">
            </el-table-column> -->

            <el-table-column prop="name" label="司机名称" min-width="140">
                <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top">
                        <p>司机编码: {{ scope.row.driver_code }}</p>
                        <div slot="reference" class="img-wrap">
                            <el-image
                                class="sexImg"
                                v-if="scope.row.sex.val != '2'&&scope.row.name!==''"
                                :src="scope.row.sex.val == '1' ? require('../../../assets/nan.png') : require('../../../assets/nv.png')"
                            ></el-image>

                            <el-tag v-if="scope.row.sex.val != '2'" size="medium" :style="scope.row.sex.val == '1'? nanTag :  nvTag"
                                >{{ scope.row.name }}
                            </el-tag>
                            <el-tag v-else size="medium" style="border: 0; background-color: #fff; color: #333"
                                >{{ scope.row.name }}
                            </el-tag>
                        </div>
                    </el-popover>
                </template>
            </el-table-column>

            <el-table-column prop="real_name" label="真实姓名" min-width="140">
                <template slot-scope="scope">
                    <span>
                        <!-- <el-image
                            style="vertical-align: middle"
                            v-if="scope.row.sex.val != '2'&&scope.row.real_name!==''&&scope.row.real_name!=null"
                            :src="scope.row.sex.val == '1' ? require('../../../assets/nan.png') : require('../../../assets/nv.png')"
                        ></el-image> -->
                        <span v-if="scope.row.sex.val != '2'" :style="scope.row.sex.val == '1' ? nanStyles : nvStyles">{{
                            scope.row.real_name
                        }}</span>
                        <span v-else>{{ scope.row.real_name }}</span>
                    </span>
                </template>
            </el-table-column>

            <el-table-column prop="level.alias" label="司机等级" min-width="140">
                <template slot-scope="scope">
                    <span> Lv.{{ scope.row.level.lv }} </span>
                </template>
            </el-table-column>

            <el-table-column prop="phone" label="手机电话" min-width="150"
                ><template slot-scope="scope">
                    <span>
                        <!-- <el-image
                            style="vertical-align: middle"
                            v-if="scope.row.sex.val != '2'&&scope.row.phone!==''"
                            :src="scope.row.sex.val == '1' ? require('../../../assets/nan.png') : require('../../../assets/nv.png')"
                        ></el-image> -->
                        <span v-if="scope.row.sex.val != '2'" :style="scope.row.sex.val == '1' ? nanStyles : nvStyles">{{
                            scope.row.phone
                        }}</span>
                        <span v-else>{{ scope.row.phone }}</span>
                    </span>
                </template>
            </el-table-column>

            <el-table-column prop="driver_points.signing_end_time.YmdHis" label="签约到期时间" min-width="150">
                <template slot-scope="scope">
                    <p v-if="scope.row.driver_or_legwork == '0'">
                        {{ scope.row.driver_points.signing_end_time.YmdHis }}
                    </p>

                    <p v-if="scope.row.driver_or_legwork == '1'">
                        {{ scope.row.driver_points.legwork_signing_end_time.YmdHis }}
                    </p>
                </template>
            </el-table-column>

            <el-table-column label="身份" min-width="100">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.capacity.val == '0' ? 'danger' : scope.row.capacity.val == '1' ? '' : 'warning'">
                        {{ scope.row.capacity.alias }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="dan" label="段位"> </el-table-column>

            <el-table-column label="工作类型" min-width="100">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.driver_or_legwork == '0' ? '' : 'warning'">
                        {{ scope.row.driver_or_legwork == '0' ? '代驾司机' : '跑腿骑手' }}
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column label="管理状态" min-width="80">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.status.val == '0' ? 'warning' : scope.row.status.val == '1' ? '' : 'danger'">
                        {{ scope.row.status.alias }}
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column prop="balance" label="钱包余额" min-width="150">
                <template slot-scope="scope">
                    <span style="color: rgb(233, 161, 6)">
                        {{ scope.row.balance }}
                    </span>
                    元
                </template>
            </el-table-column>
            <el-table-column prop="balance" label="保险状态" min-width="150">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.insurance_status.val == '2' ? 'success' : 'danger'">
                        {{ scope.row.insurance_status.alias }}</el-tag
                    >
                </template>
            </el-table-column>

            <el-table-column prop="balance" label="签约规则" min-width="150">
                <template slot-scope="scope">
                    {{
                        scope.row.driver_points.signing_type == '0'
                            ? '按天签约'
                            : scope.row.driver_points.signing_type == '1'
                            ? '按月签约'
                            : '按单签约'
                    }}
                </template>
            </el-table-column>

            <el-table-column label="警示灯" min-width="150">
                <template slot-scope="scope">
                    <img src="../../../assets/yellow.png" alt="" style="width: 20px; height: 20px" v-if="scope.row.alarm == 1" />
                    <img src="../../../assets/red.png" alt="" style="width: 20px; height: 20px" v-if="scope.row.alarm == 2" />
                </template>
            </el-table-column>

            <el-table-column label="操作" min-width="150">
                <template slot-scope="scope">
                    <el-dropdown
                        split-button
                        type="primary"
                        @click="
                            edit_isShow = !edit_isShow;
                            driver_code_children = scope.row.driver_code;
                        "
                        trigger="click"
                    >
                        编辑

                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="untying(scope.row.driver_code)">解绑设备</el-dropdown-item>

                            <el-dropdown-item
                                @click.native="
                                    editPassword_show = !editPassword_show;
                                    driver_code_children = scope.row.driver_code;
                                "
                            >
                                修改密码
                            </el-dropdown-item>

                            <el-dropdown-item
                                @click.native="
                                    determine_isShow = !determine_isShow;
                                    driver_code_children = scope.row.driver_code;
                                "
                            >
                                审核判定
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="open(scope.row.driver_code)"> 保险审核 </el-dropdown-item>

                            <!-- <el-dropdown-item @click.native="toSigning(scope.row.driver_code)" v-if="driver_deduct_day=='1' && scope.row.driver_or_legwork == '0'">
                                续费签约
                            </el-dropdown-item> -->

                            <el-dropdown-item
                                @click.native="toSigningLegwork(scope.row.driver_code)"
                                v-if="driver_signing_date == '1' && scope.row.driver_or_legwork == '1'"
                            >
                                签约骑手
                            </el-dropdown-item>

                            <el-dropdown-item
                                v-if="driver_deduct_day == '1'"
                                @click.native="
                                    subSigning_isShow = !subSigning_isShow;
                                    driver_code_children = scope.row.driver_code;
                                    driver_or_legwork = scope.row.driver_or_legwork;
                                "
                            >
                                扣除签约天数
                            </el-dropdown-item>

                            <!-- <el-dropdown-item
                              @click.native="wallet_isShow =!wallet_isShow; driver_code_children = scope.row.driver_code;">司机钱包
                            </el-dropdown-item> -->

                            <el-dropdown-item
                                @click.native="
                                    capital_isShow = !capital_isShow;
                                    driver_code_children = scope.row.driver_code;
                                    driver_name = scope.row.name;
                                    driver_phone = scope.row.phone;
                                "
                            >
                                司机资金流水
                            </el-dropdown-item>

                            <el-dropdown-item
                                v-if="driver_signing_date == '1'"
                                @click.native="
                                    data_isShow = !data_isShow;
                                    driver_code_children = scope.row.driver_code;
                                    driver_or_legwork = scope.row.driver_or_legwork;
                                    driver_name = scope.row.name;
                                    driver_phone = scope.row.phone;
                                "
                            >
                                调整签约日期
                            </el-dropdown-item>
                            <el-dropdown-item
                                v-if="driver_job == '1'"
                                @click.native="
                                    SigningType_isShow = !SigningType_isShow;
                                    driver_code_children = scope.row.driver_code;
                                    driver_or_legwork = scope.row.driver_or_legwork;
                                    driver_name = scope.row.name;
                                    driver_phone = scope.row.phone;
                                    signing_type = scope.row.driver_points.signing_type;
                                "
                            >
                                调整签约类型
                            </el-dropdown-item>
                            <!-- <el-dropdown-item

                                @click.native="
                                    SigningType_isShow = !SigningType_isShow;
                                    driver_code_children = scope.row.driver_code;
                                    driver_or_legwork = scope.row.driver_or_legwork;
                                    driver_name = scope.row.name;
                                    driver_phone = scope.row.phone;
                                "
                            >
                                调整签约类型测试用
                            </el-dropdown-item> -->

                            <el-dropdown-item
                                @click.native="
                                    grabbing_isShow = !grabbing_isShow;
                                    driver_code_children = scope.row.driver_code;
                                    driver_name = scope.row.name;
                                "
                            >
                                司机抢单记录
                            </el-dropdown-item>

                            <el-dropdown-item
                                @click.native="
                                    driverTime_isShow = !driverTime_isShow;
                                    driver_code_children = scope.row.driver_code;
                                    driver_name = scope.row.name;
                                "
                            >
                                司机上线记录
                            </el-dropdown-item>

                            <el-dropdown-item
                                @click.native="
                                    driverAchievement_isShow = !driverAchievement_isShow;
                                    driver_code_children = scope.row.driver_code;
                                "
                            >
                                司机业绩信息
                            </el-dropdown-item>

                            <el-dropdown-item
                                v-if="driver_driverpoints_add == '1'"
                                @click.native="
                                    editRank_isShow = !editRank_isShow;
                                    driver_code_children = scope.row.driver_code;
                                "
                            >
                                修改司机段位
                            </el-dropdown-item>

                            <!-- <el-dropdown-item
                              @click.native="online_isShow =!online_isShow; driver_code_children = scope.row.driver_code; driver_name = scope.row.name;driver_phone = scope.row.phone;">
                              司机上下线时间
                            </el-dropdown-item> -->
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>

        <!-- 批量删除按钮 -->
        <!-- <el-button type="primary" icon="el-icon-delete" class="handle-del mr10" @click="deleteData"
          style="margin-top: 20px;">批量删除</el-button> -->

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>

        <!-- 修改密码组件 -->
        <editPassword :isShow="editPassword_show" @onSubmit="driverLists" :data="driver_code_children"></editPassword>

        <!-- 添加组件 -->
        <addDriverDrawer :isShow="add_isShow" @onSubmit="addDriverSubmit"></addDriverDrawer>
        <!-- 时间段司机资金流水组件 -->
        <waterDriverDrawer :isShow="water_isShow"></waterDriverDrawer>

        <!-- 编辑组件 -->
        <editDriverDrawer :isShow="edit_isShow" :data="driver_code_children" @onSubmit="driverLists"></editDriverDrawer>

        <!-- 添加优享司机组件 -->
        <enjoyDriver :data="driver_code_children" :isShow="enjoy_isShow" @onSubmit="driverLists"></enjoyDriver>

        <!-- 续费签约组件 -->
        <!-- <signing :data="driver_code_children" :isShow="signing_isShow"
                 @onSubmit="driverLists"></signing> -->

        <!--        签约骑手      -->
        <signingLegwork :data="driver_code_children" :isShow="signingLegwork_isShow" @onSubmit="driverLists"></signingLegwork>
        <!-- 扣除签约天数组件 -->
        <subSigning
            :data="driver_code_children"
            :isShow="subSigning_isShow"
            :driver_or_legwork="driver_or_legwork"
            @onSubmit="driverLists"
        ></subSigning>

        <!-- 司机钱包组件 -->
        <!-- <driverWallet :data="driver_code_children" :isShow="wallet_isShow"></driverWallet> -->

        <!-- 审核判定组件 -->
        <toDetermine :data="driver_code_children" :isShow="determine_isShow" @onSubmit="driverLists"></toDetermine>

        <!-- 司机抢单记录组件 -->
        <driverGrabbing :data="driver_code_children" :isShow="grabbing_isShow" :name="driver_name"></driverGrabbing>

        <!-- 司机资金流水组件 -->
        <driverCapitalFlow
            :data="driver_code_children"
            :isShow="capital_isShow"
            :driverName="driver_name"
            :driverPhone="driver_phone"
            @onSubmit="driverLists"
        ></driverCapitalFlow>

        <!-- 调整签约日期组件 -->
        <driverChangeData
            :data="driver_code_children"
            :driverName="driver_name"
            :driver_or_legwork="driver_or_legwork"
            :driverPhone="driver_phone"
            :isShow="data_isShow"
        ></driverChangeData>
        <!-- 调整司机签约类型组件 -->
        <editSigningType
            :data="driver_code_children"
            :driverName="driver_name"
            :driver_or_legwork="driver_or_legwork"
            :driverPhone="driver_phone"
            :isShow="SigningType_isShow"
            :signing_type="signing_type"
            @onSubmit="driverLists"
        ></editSigningType>

        <!-- 司机上下线时间 -->
        <!-- <driverOnlineTime :data="driver_code_children" :isShow="online_isShow" :driverName="driver_name"
          :driverPhone="driver_phone">
        </driverOnlineTime> -->

        <!-- 司机上下线 -->
        <driverTime
            :data="driver_code_children"
            :isShow="driverTime_isShow"
            :driverName="driver_name"
            :driverPhone="driver_phone"
        ></driverTime>

        <!-- 司机业绩信息组件 -->
        <driverAchievement :isShow="driverAchievement_isShow" :data="driver_code_children"></driverAchievement>

        <!-- 修改段位组件 -->
        <editRank :isShow="editRank_isShow" @onSubmit="driverLists" :data="driver_code_children"></editRank>
    </div>
</template>

<script>
var _this;
import echarts from 'echarts';

import axios from 'axios';
import { config } from '@/utils/config';
import addDriverDrawer from './addDriverDrawer.vue';
import waterDriverDrawer from './waterDriverDrawer.vue';
import editPassword from './editPassword.vue';
import editDriverDrawer from './editDriverDrawer.vue';
import enjoyDriver from './enjoyDriver.vue';
import signing from './signing.vue';
import driverWallet from './driverWallet.vue';
import toDetermine from '../determine/toDetermine.vue';
// import driverRecord from './driverRecord.vue';
import subSigning from './subSigning.vue';
import signingLegwork from './signingLegwork.vue';

import driverCapitalFlow from './driverCapitalFlow.vue';
import driverChangeData from './driverChangeData.vue';
import editSigningType from './editSigningType.vue';

// import driverOnlineTime from './driverOnlineTime.vue';
import driverGrabbing from './driverGrabbing.vue';
import driverTime from './driverTime.vue';
import driverAchievement from './driverAchievement.vue';
import editRank from './editRank.vue';
import bus from '../../common/bus.js';

export default {
    components: {
        addDriverDrawer,
        waterDriverDrawer,
        editPassword,
        editDriverDrawer,
        enjoyDriver,
        signing,
        driverWallet,
        toDetermine,
        // driverRecord,
        subSigning,
        driverCapitalFlow,
        driverChangeData,
        editSigningType,
        // driverOnlineTime,
        driverGrabbing,
        driverTime,
        driverAchievement,
        editRank,
        signingLegwork
    },
    data() {
        return {
            nanTag: {
                color: '#10a4f2',
                border: 0,
                backgroundColor: '#fff'
            },
            nvTag: {
                color: '#ff66a7',
                border: 0,
                backgroundColor: '#fff'
            },
            nanStyles: {
                color: '#10a4f2'
            },
            nvStyles: {
                color: '#ff66a7'
            },
            // nanUrl: `url(${require('../../../assets/nan.png')})`, // 是背景图片的时候才要加url
            // nvUrl: `url(${require('../../../assets/nv.png')})`,// 是背景图片的时候才要加url

            line_value: '0', // 折线图默认查询

            search_data_line: {
                type: '0' //0 是日 1是月

                // city_code: sessionStorage.getItem("city_code"),
                // city_tag: JSON.parse(localStorage.getItem("city_tag")).city_tag,
            },
            echarts_loading: true,

            activeChartsDriver_text: '正在请求中...',
            // 折线图
            activeChartsDriver: '',

            // 折线图数据
            activeOption: {
                title: {
                    text: '司机数量趋势图',

                    textStyle: {
                        fontSize: 14,
                        fontWeight: 700
                    }
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['有效司机', '签约司机', '续约司机', '解约司机', '封禁司机', '逾期司机'],
                    left: 110,
                    textStyle: {
                        // color: ['#05c0ab','#409EFF', '#0aa707', '#9aa7b7', '#835fa9', '#ff3300'] // 设置图例文字的颜色
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                toolbox: {},
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: [],
                    axisLabel: {
                        rotate: -85
                    }
                },
                yAxis: {
                    type: 'value',
                    minInterval: 1
                },
                series: []
            },
            capacity: '',
            driver_driverpoints_add: JSON.parse(localStorage.getItem('login')).driver_driverpoints_add,
            driver_signing_date: JSON.parse(localStorage.getItem('login')).driver_signing_date,
            driver_insurance: JSON.parse(localStorage.getItem('login')).driver_insurance,
            driver_deduct_day: JSON.parse(localStorage.getItem('login')).driver_deduct_day,
            driver_job: JSON.parse(localStorage.getItem('login')).driver_job,

            search_time: '',
            signing_type: '',

            insurance_status: [],

            editRank_isShow: false,

            subSigning_isShow: false,

            signingLegwork_isShow: false,

            // 司机资金流水组件开关
            capital_isShow: false,

            //调整签约日期开关
            data_isShow: false,
            SigningType_isShow: false,

            // 司机上下线开关
            driverTime_isShow: false,

            // 司机业绩信息组件开关
            driverAchievement_isShow: false,

            // 司机抢单记录组件
            grabbing_isShow: false,

            // 修改密码开关
            editPassword_show: false,

            driver_or_legwork: '',

            // 司机名称
            driver_name: '',

            //司机电话
            driver_phone: '',

            // 选项卡默认选中项
            activeName: 'all',

            // 传入子组件的数据
            driver_code_children: '',

            //详细搜索
            more_search: false,

            // 批量删除
            delDriverSubmit_data: {
                driver_code_array: []
            },
            delDriverSubmit_rules: {
                driver_code_array: {
                    placeholder: '权限模块',
                    rules: {
                        required: false,
                        message: '权限模块代码数组(json)',
                        regulation: 'special',
                        rulesData: 'json_array'
                    }
                }
            },

            // 抽屉开关按钮
            edit_isShow: false,
            add_isShow: false,
            water_isShow: false,

            //  优享司机开关
            enjoy_isShow: false,

            // 续费签约组件开关
            // signing_isShow: false,

            // 司机钱包组件开关
            wallet_isShow: false,

            // 司机账单组件开关
            record_isShow: false,

            // 审核判定开关
            determine_isShow: false,
            determine_drawer: '',

            //司机上下线开关
            online_isShow: false,

            // 下拉搜索性别
            value_sex_code: '',
            val_sex_array: '',
            val_capacity_array: [],

            // 下拉搜索管理状态
            value_status_code: '',
            value_status_array: [],

            // 存放表格数据
            tableData: [],

            //翻页数据
            search_data: {
                page: 1,
                limit: 10,
                name: '',
                phone: '',
                sex: '',
                status: '',
                real_name: '',
                id_card: '',
                insurance_alarm: '',
                fixed_array: '',
                signing_type: '',
                insurance_status: '',
                capacity: '',
                dan: ''
            },
            dan_select: '',

            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        _this.driverLineChart();

        _this.driverLists();
        _this.getDan();

        // 接收子组件传来的事件并初始化列表
        bus.$on('onSubmit', (msg) => {
            _this.driverLists();
        });
    },

    methods: {
        // 获取折线图数据
        driverLineChart() {
            // _this.loading = true;

            _this.echarts_loading = false;

            _this.activeOption.xAxis.data = [];
            _this.activeOption.series = [];

            _this
                .$post('/statistics/driverLineChart', _this.search_data_line)
                .then((res) => {
                    // 折现颜色数组
                    let color = ['#05c0ab', '#409EFF', '#0aa707', '#9aa7b7', '#835fa9', '#ff3300'];
                    _this.activeOption.series = []; // 防止数组重复累加
                    // 往series数组里面动态添加数据对象
                    for (let i = 0; i < _this.activeOption.legend.data.length; i++) {
                        _this.activeOption.series.push({
                            name: _this.activeOption.legend.data[i],
                            type: 'line',
                            data: [],
                            smooth: true,
                            color: color[i],
                            itemStyle: {
                                normal: {
                                    label: {
                                        formatter: '{c}',
                                        show: true,
                                        position: 'top',
                                        textStyle: {
                                            fontWeight: 'bolder',
                                            fontSize: '12',
                                            color: color[i]
                                        }
                                    },
                                    opacity: 1
                                }
                            }
                        });
                    }

                    for (let i = 0; i < res.data.length; i++) {
                        // 添加x轴数据
                        _this.activeOption.xAxis.data.push(res.data[i].date);
                        _this.activeOption.series[0].data.push(res.data[i].effective_nums); //添加有效司机数据
                        _this.activeOption.series[1].data.push(res.data[i].sign_nums); //添加签约司机数据
                        _this.activeOption.series[2].data.push(res.data[i].renewal_nums); //添加续约司机数据
                        _this.activeOption.series[3].data.push(res.data[i].termination_nums); //添加解约司机数据
                        _this.activeOption.series[4].data.push(res.data[i].ban_nums); //添加封禁司机数据
                        _this.activeOption.series[5].data.push(res.data[i].overdue_nums); //添加逾期司机数据
                    }

                    // _this.loading = false;

                    // let aaa = [
                    //     {
                    //         month: '2024-06',
                    //         data: [
                    //             {
                    //                 name: '有效司机',
                    //                 num: '100'
                    //             },
                    //             {
                    //                 name: '签约司机',
                    //                 num: '210'
                    //             }
                    //         ]
                    //     },
                    //     {
                    //         month: '2024-07',
                    //         data: [
                    //             {
                    //                 name: '有效司机',
                    //                 num: '300'
                    //             },
                    //             {
                    //                 name: '签约司机',
                    //                 num: '510'
                    //             }
                    //         ]
                    //     }
                    // ];

                    // for (let index = 0; index < aaa[0].data.length; index++) {
                    //     // _this.activeOption.legend.push(aaa[0].data[index].name)

                    //     console.log(index, '------');

                    //     _this.activeOption.series.push({
                    //         name: aaa[0].data[index].name,
                    //         type: 'line',
                    //         data: [],
                    //         smooth: true,
                    //         color: '#409eff',
                    //         itemStyle: {
                    //             normal: {
                    //                 label: {
                    //                     formatter: '{c}',
                    //                     show: true,
                    //                     position: 'top',
                    //                     textStyle: {
                    //                         fontWeight: 'bolder',
                    //                         fontSize: '12',
                    //                         color: '#409eff'
                    //                     }
                    //                 },
                    //                 opacity: 1
                    //             }
                    //         }
                    //     });
                    // }
                    // console.log(_this.activeOption.series, '_this.activeOption.series');

                    // for (let i = 0; i < aaa.length; i++) {
                    //     _this.activeOption.xAxis.data.push(aaa[i].month);

                    //     let bbb = aaa[i].data;

                    //     for (let j = 0; j < bbb.length; j++) {
                    //         _this.activeOption.series[i].data.push(bbb[j].num);
                    //     }
                    //     console.log(_this.activeOption, '_this.activeOption.series222');
                    // }

                    _this.activeChartsDriver = echarts.init(document.getElementById('activeChartsDriver'));

                    _this.activeChartsDriver.setOption(_this.activeOption);

                    _this.echarts_loading = true;
                    // 浏览器缩放，图表等比例缩放
                    window.addEventListener('resize', function () {
                        _this.activeChartsDriver.resize();
                    });
                })
                .catch((err) => {});
        },
        // 折线图change查询
        linChange(val) {
            _this.search_data_line.type = val;

            _this.driverLineChart();
        },
        getDan() {
            // axios.defaults.baseURL = config.axios_normalURL;
            this.$post('/system/dan',{},{},'normal').then((res) => {
                // axios.defaults.baseURL = config.axios_baseURL; //请求base url
                this.dan_select = res.data;
            });
            // axios.defaults.baseURL = config.axios_baseURL; //请求base url
        },
        open(driverCode) {
            this.$confirm('是否确认审批通过?', '提示', {
                confirmButtonText: '通过',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    _this
                        .$post('/driver/executeDriverInsuranceSubmit', { driver_code: driverCode })
                        .then((res) => {
                            this.$message({
                                type: 'success',
                                message: res.msg
                            });
                            _this.driverLists();
                        })
                        .catch((err) => {});
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
        },

        // 注册时间change方法
        timeChange(val) {
            if (val != null) {
                _this.search_data.fixed_array = JSON.stringify(['between'].concat(val));
            } else {
                _this.search_data.fixed_array = '';
            }
        },

        // 签约骑手
        toSigningLegwork(driverCode) {
            _this.signingLegwork_isShow = !_this.signingLegwork_isShow;
            _this.driver_code_children = driverCode;
        },

        toSigning(driverCode) {
            _this.signing_isShow = !_this.signing_isShow;
            _this.driver_code_children = driverCode;
        },

        searchDriverLists() {
            _this.search_data.page = 1;
            _this.driverLists();
        },

        // 选项卡选中事件
        handleClick(tab, event) {
            // 点击的选项卡所对应的val值

            if (tab.name != 'all') {
                _this.search_data.status = tab.name;
            } else {
                _this.search_data.status = '';
            }
            _this.search_data.page = 1;
            _this.driverLists();
        },

        // 添加司机成功
        addDriverSubmit() {
            _this
                .$post(
                    '/driver/driverLists',
                    {
                        page: 1,
                        limit: 10,
                        name: '',
                        phone: '',
                        sex: '',
                        status: ''
                    },
                    _this.search_rules
                )
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;
                    _this.result_data = res;
                })
                .catch((err) => {});
        },

        // 搜索司机列表
        driverLists() {
            _this
                .$post('/driver/driverLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;
                    _this.result_data = res;
                    _this.capacity = _this.tableData[0].capacity.select_array;

                    _this.val_sex_array = _this.tableData[0].sex.select_array;
                    _this.capacity = _this.tableData[0].capacity.select_array;
                    _this.value_status_array = _this.tableData[0].status.select_array;
                    _this.insurance_status = _this.tableData[0].insurance_status.select_array;
                })
                .catch((err) => {});
        },

        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.driverLists();
        },

        handleSelectionChange(val) {
            var datalist = [];

            for (var i in val) {
                datalist.push(val[i].driver_code);
            }
            _this.delDriverSubmit_data.driver_code_array = datalist;
        },

        // 批量删除
        deleteData() {
            if (_this.delDriverSubmit_data.driver_code_array.length == 0) {
                _this.$message.error({
                    message: '请至少勾选一条数据',
                    duration: 1500
                });
                return;
            }

            _this
                .$confirm('此操作将删除该条数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',

                    cancelButtonText: '取消',

                    type: 'warning'
                })
                .then(() => {
                    _this.delDriverSubmit_data.driver_code_array = JSON.stringify(_this.delDriverSubmit_data.driver_code_array);

                    _this
                        .$post('/driver/delDriverSubmit', _this.delDriverSubmit_data, _this.delDriverSubmit_rules)
                        .then((res) => {
                            _this.$message.success({
                                message: '删除成功',
                                duration: 1500
                            });
                            //初始化显示列表
                            _this.driverLists();
                        })
                        .catch((err) => {});
                })
                .catch(() => {
                    _this.$message({
                        message: '已取消删除',
                        duration: 1500
                    });
                });
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        },

        // 解绑设备
        untying(code) {
            _this
                .$confirm('此操作将解绑该条数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',

                    cancelButtonText: '取消',

                    type: 'warning'
                })
                .then(() => {
                    _this
                        .$post('/driver/untyingDriverMobileSubmit', {
                            driver_code: code
                        })
                        .then((res) => {
                            _this.$message.success({
                                message: '解绑设备成功',
                                duration: 1500
                            });
                            _this.driverLists();
                        })
                        .catch((err) => {});
                })
                .catch(() => {});
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    max-width: 150px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
.img-wrap{
    display: flex;
    align-items: center;
}
.sexImg{
    display: block;
    width: 14px;
    height: 14px;
}
</style>
